// extracted by mini-css-extract-plugin
export default {"container":"pK-z","topReviewHeading":"qK-z","criticalReview":"rK-z","favorableReview":"sK-z","vsSeparator":"tK-z"};